module.exports = {
  src: __webpack_public_path__ + "assets/images/headerLogo.310525d6386fd129.png",
  width: 222,
  height: 86,
  toString: function() { return __webpack_public_path__ + "assets/images/headerLogo.310525d6386fd129.png"; }
};